// flow
// TODO(Oded): flow disabled due to SVGGraphicsElement not recognized
import React, {PureComponent} from "react";
import {Marker} from "react-google-maps";
import {
    getBottomCenterAnchorFromSVG,
    getCenterAnchorFromSVG,
    getSVGObject,
    SVGToBase64Url
} from "../../../Utils/SVGUtils";
import {Motion, spring} from "react-motion";

export const SVGAnchor = Object.freeze({"BOTTOM_CENTER": 0, "MIDDLE_CENTER": 1});
export type SVGAnchorType = $Values<typeof SVGAnchor>;
export type SVGPosition = { lat: number, lng: number, bearing: number };


export type SVGMarkerState = {|
    iconURL: string,
    iconSVG?: SVGGraphicsElement,
    previousPosition?: SVGPosition,
    currentPosition?: SVGPosition,
|};

export type SVGMarkerProps = {|
    iconPath: string,
    visible: boolean,
    lat: number,
    lng: number,
    bearing?: number,
    icon?: Object,
    derivedStateFromProps?: (props: Object, state: Object) => SVGMarkerState,
    anchorPosition?: SVGAnchorType,
    useMotion?: boolean,
|};

class SVGMarker extends PureComponent<SVGMarkerProps, SVGMarkerState> {
    constructor(props: SVGMarkerProps) {
        super(props);
        this.state = {
            iconURL: props.iconPath,
            iconSVG: undefined,
            previousPosition: undefined,
            currentPosition: undefined,
        };
    }

    componentDidMount() {
        getSVGObject(this.props.iconPath).then((svg: SVGGraphicsElement) => {
            const newState = {
                iconURL: SVGToBase64Url(svg),
                iconSVG: svg,
            };
            if (this.props.derivedStateFromProps) {
                this.setState(this.props.derivedStateFromProps(this.props, newState));
            } else {
                this.setState(newState);
            }
        });
    }

    static getDerivedStateFromProps(props: SVGMarkerProps, state: SVGMarkerState) {
        state.previousPosition = state.currentPosition;
        state.currentPosition = getPositionFromProps(props);
        if (state.iconSVG && props.derivedStateFromProps) {
            return {...state, ...props.derivedStateFromProps(props, state)};
        }
        return state;
    }


    render() {
        let anchor;
        if (this.props.anchorPosition === SVGAnchor.BOTTOM_CENTER) {
            anchor = getBottomCenterAnchorFromSVG(this.state.iconSVG);
        } else if (this.props.anchorPosition === SVGAnchor.MIDDLE_CENTER) {
            anchor = getCenterAnchorFromSVG(this.state.iconSVG);
        }
        const markerProps = {
            visible: this.props.visible,
            position: getPositionFromProps(this.props),
            icon: {
                anchor: anchor,
                ...(this.props.icon || {}),
                url: this.state.iconURL,
            }
        };
        const previous = this.state.previousPosition;
        const current = this.state.currentPosition;
        if (this.props.useMotion && previous && current) {

            const springOptions = {
                stiffness: 85,
                damping: 23,
            };
            const scalingFactor = 100;
            return (
                <Motion
                    defaultStyle={{
                        lat: previous.lat * scalingFactor,
                        lng: previous.lng * scalingFactor,
                    }}
                    style={{
                        lat: spring(current.lat * scalingFactor, springOptions),
                        lng: spring(current.lng * scalingFactor, springOptions),
                    }}
                >
                    {style => <Marker {...markerProps} position={{
                        lat: style.lat / scalingFactor,
                        lng: style.lng / scalingFactor
                    }}/>}
                </Motion>
            );
        }
        return (<Marker {...markerProps}/>);
    }
}

const getPositionFromProps = (props: SVGMarkerProps): SVGPosition => {
    return {
        lat: props.lat,
        lng: props.lng,
        bearing: props.bearing,
    };
};

export default SVGMarker;



// WEBPACK FOOTER //
// ./src/Components/Map/Markers/SVGMarker.js